<script >
import {defineComponent} from "vue";
import http from "@/plugins/axios";

var numeral = require("numeral");
export default defineComponent({
  name: 'orders-view',
  data: () => ({
    orders :  {
      data: [],
    },
  }),
  methods:{
    showFormat(price){
      return numeral(price).format("0,0");
    },
    getorder(){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/getorders", { headers: { Authorization: AuthStr } })
          .then(response => {
            this.orders = response.data;
            // console.log( response.data);
          })
          .catch((error) => {
          });
    }
  },
  mounted() {
    this.getorder();
  }
})
</script>

<template>
  <v-main class="main" >
    <div v-if="orders.data.length > 0">
      <template v-for="(order, index)  in orders.data" :key="index">
        <div class="col-12" style="margin: 20px auto;min-height: 100px;background: rgb(31, 162, 157);border-radius: 15px;max-width: 94%;padding: 15px 10px 10px 10px;position: relative">
          <div class="col-12 ttt" style="padding: 10px;color: #000;border-bottom: 1px solid #ffffff">
            <div class="col-4 float-right">شماره سفارش :</div>
            <div class="col-8 float-right text-left" style="padding-left: 15px">{{order.factor_id}} </div>
            <div class="clearfix"></div>
          </div>
          <div class="col-12 ttt" style="padding: 10px;color: #000;border-bottom: 1px solid #ffffff">
            <div class="col-4 float-right">وضعیت سفارش :</div>
            <div class="col-8 float-right text-left" style="padding-left: 15px">
              <template v-if="order.status=='paid'">
                پرداخت شده
              </template>
              <template v-else>
                پرداخت نشده
              </template>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="col-12 ttt" style="padding: 10px;color: #000;border-bottom: 1px solid #ffffff">
            <div class="col-4 float-right">نحوه پرداخت :</div>
            <div class="col-8 float-right text-left" style="padding-left: 15px">
              <template v-if="order.type_peyment=='online'">
                آنلاین
              </template>
              <template v-if="order.type_peyment=='check'">
                مدت دار
              </template>
              <template v-if="order.type_peyment=='many'">
                واریز به حساب
              </template>
            </div>
            <div class="clearfix"></div>
          </div>
          <div  v-if="order.type_peyment=='online' && order.status=='paid'" class="col-12 ttt" style="padding: 10px;color: #000;border-bottom: 1px solid #ffffff">
            <div class="col-4 float-right">کد پیگیری:</div>
            <div class="col-8 float-right text-left" style="padding-left: 15px">{{order.trace}} </div>
            <div class="clearfix"></div>
          </div>
          <div  v-if="order.type_peyment=='online' && order.status=='paid'" class="col-12 ttt" style="padding: 10px;color: #000;border-bottom: 1px solid #ffffff">
            <div class="col-4 float-right">تاریخ پرداخت:</div>
            <div class="col-8 float-right text-left" style="padding-left: 15px;direction: rtl">{{order.persian_pay}} </div>
            <div class="clearfix"></div>
          </div>
          <div class="col-12 ttt" style="padding: 10px;color: #000;border-bottom: 1px solid #ffffff">
            <div class="col-4 float-right">نحوه ارسال :</div>
            <div class="col-8 float-right text-left" style="padding-left: 15px">
              <template v-if="order.delivery=='peack'">
                پیک موتوری
              </template>
              <template v-if="order.delivery=='tipax'">
                تیپاکس
              </template>
              <template v-if="order.delivery=='vatan'">
                باربری وطن
              </template>
              <template v-if="order.delivery=='javangir'">
                باربری جهانگیر
              </template>
            </div>
            <div class="clearfix"></div>
          </div>
          <template v-if="order.type_peyment=='check' && order.status=='unpaid'">

          </template>
          <template v-else>
            <div class="col-12 ttt" style="padding: 10px;color: #000;border-bottom: 1px solid #ffffff">
              <div class="col-4 float-right">جمع کل:</div>
              <div class="col-8 float-right text-left" style="padding-left: 15px">{{showFormat(order.price+order.discount)}} ریال</div>
              <div class="clearfix"></div>
            </div>
            <div class="col-12 ttt" style="padding: 10px;color: #000;border-bottom: 1px solid #ffffff">
              <div class="col-4 float-right">تخفیف اپ:</div>
              <div class="col-8 float-right text-left" style="padding-left: 15px">{{showFormat(order.discount)}} ریال</div>
              <div class="clearfix"></div>
            </div>
            <div v-if="order.status=='paid'" class="col-12 ttt" style="padding: 10px;color: #000;border-bottom: 1px solid #ffffff">
              <div class="col-4 float-right">مبلغ پرداخت شده:</div>
              <div class="col-8 float-right text-left" style="padding-left: 15px">{{showFormat(order.price)}} ریال</div>
              <div class="clearfix"></div>
            </div>
            <div v-else class="col-12 ttt" style="padding: 10px;color: #000;">
              <div class="col-4 float-right">مبلغ پرداخت شده:</div>
              <div class="col-8 float-right text-left" style="padding-left: 15px">{{showFormat(order.price)}} ریال</div>
              <div class="clearfix"></div>
            </div>
            <div class="col-12 ttt" style="padding: 10px;color: #000;" v-if="order.status=='paid'">
              <div  class="col-6 float-right" style="margin: 3px auto;background: #ffc600;text-align: center;border-radius: 5px ;padding: 10px;color: #000">
                دانلود فاکتور
              </div>
              <div  class="col-6 float-right" style="margin: 3px auto;background: #73008f;text-align: center;border-radius: 5px ;padding: 10px;">
                خرید مجدد
              </div>
              <div class="clearfix"></div>
            </div>
          </template>
        </div>
      </template>
    </div>
    <div v-else>
      <h2 style="font-size: 1.2rem;text-align: center;color: rgb(31, 162, 157)">سفارش برای شما وجود ندارد</h2>
    </div>
  </v-main>
</template>

<style scoped>
.main{
  padding: 60px 0 0px;
  height: calc(100% +100px);
}
.ttt{
  font-size: 0.75rem;
  direction: rtl;
  color:#fff !important;
}
</style>